import {
  callApi
} from "./Api";

export const GET_SUB_STATS = 'GET_SUB_STATS';
export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const GET_ALL_SEARCH_RESULTS = 'GET_ALL_SEARCH_RESULTS';

export const getSubStats = () => (dispatch, getState) => {
  const url = 'clients/subscription/stats';
  callApi(dispatch, getState, GET_SUB_STATS, url);
}

export const getSearchData = (obj) => (dispatch, getState) => {
  const url = 'clients/stats/details/search';
  callApi(dispatch, getState, GET_SEARCH_RESULTS, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}
export const getAllSearchData = (obj) => (dispatch, getState) => {
  const url = 'clients/stats/details/search';
  callApi(dispatch, getState, GET_ALL_SEARCH_RESULTS, url, {
    method: 'POST',
    body: JSON.stringify(obj)
  })
}


// WEBPACK FOOTER //
// ./src/actions/SubscriptionInfo.js